module.exports = __webpack_public_path__ + "img/lk-hover.5c8185f8.svg";